import { TaskStatus } from 'app/constants/taskStatus'

export const getTaskStatusName = (
  taskStatus: TaskStatus,
  translate: (string) => string,
): string => {
  const text: string = TaskStatus[taskStatus]
  return translate(`taskStatus.${text}`)
}
